var stopNextPropagation = false;
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
       const skipToContentBtn = document.querySelector('.skip-to-content-link');
       const shopifySections = document.querySelectorAll('.shopify-section');
       const drawer = document.querySelector('.drawer');

      const removeModal = new tingle.modal({
        footer: true,
        closeMethods: [],
        closeLabel: '',
        cssClass: ['cart-remove--modal'],
        onOpen: () => {
          this.tingleTabNav();
          removeModal.modal?.setAttribute("role", "dialog");
          removeModal.modal?.setAttribute("aria-modal", "true");
          if (skipToContentBtn) {
            skipToContentBtn.setAttribute('inert', '');
          }
          shopifySections.forEach(element => {
            element.setAttribute('inert', ''); 
          });
          if (drawer) {
            drawer.setAttribute('inert', '');
          }
        },
        onClose: () => {
          const removeBtn = this.querySelector("a, button");
          removeModal.modal?.removeAttribute("role");
          removeModal.modal?.removeAttribute("aria-modal");
          if (skipToContentBtn) {
            skipToContentBtn.removeAttribute('inert');
          }
          shopifySections.forEach(element => {
            element.removeAttribute('inert'); 
          });
          if (drawer) {
            drawer.removeAttribute('inert');
          }
          removeModal.destroy();
          setTimeout(() => {
            removeBtn.focus();
          }, 800);
        },
      });

      removeModal.setContent('<p id="remove-item">Are you sure you would like to remove this item from the shopping cart?</p>');
      removeModal.addFooterBtn('Cancel', 'tingle-btn tingle-btn-cancel', () => {
        removeModal.close();
      });

      removeModal.addFooterBtn('Ok', 'tingle-btn tingle-btn-remove', () => {
        removeModal.close();
        this.checkRemovedItem(this.parentNode.querySelector('.quantity__input'));
        const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
        
        const cartItemRow = this.closest('.cart-item');

        if (cartItemRow) {
          const titleEl = cartItemRow.querySelector('.cart-item__details a');

          if (titleEl) {
            const titleElText = titleEl.textContent.trim();
            const removeItemContainer = document.getElementById('remove-item-announcement');

            let delay = 100;

            const userAgent = navigator.userAgent.toUpperCase();
            if (userAgent.indexOf('MAC OS') > -1) {
              delay = 1600;
            }

            if (removeItemContainer) {
              setTimeout(() => {
                removeItemContainer.textContent = '';
                removeItemContainer.textContent = `${titleElText} has been removed`;
              }, delay);
            }
          }
        }
        
        cartItems.updateQuantity(this.dataset.index, 0);
        
      });

      removeModal.open();
    });
  }

  tingleTabNav() {
    const modal = document.querySelector('.tingle-modal');
    const focusableElements = getFocusableElements(modal);
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length -1];

    if (focusableElements.length > 0) {
      focusableElements[0].focus();
    }

    focusableElements.forEach(element => {
      element.setAttribute('aria-describedby', 'remove-item');
    })

    function trapFocus(evt) {
      const isTab = evt.key === 'Tab';

      if (!isTab) return;

      const isShiftTab = evt.shiftKey;
      const activeElement = document.activeElement;

      if (isShiftTab && activeElement === firstElement) {
        evt.preventDefault();
        lastElement.focus();
      } else if (!isShiftTab && activeElement === lastElement) {
        evt.preventDefault();
        firstElement.focus();
      }
    }

    modal.addEventListener('keydown', trapFocus);
  }

  checkRemovedItem(input) {
    stopNextPropagation = true;
    let hasPurchaseLimitEnabled = input.hasAttribute('data-quantity-inp');
    if (!(hasPurchaseLimitEnabled)) return;
    if (hasPurchaseLimitEnabled) {
      let prodId = parseInt(input.getAttribute('data-quantity-inp')),
        currentQty = parseInt(input.value);
      var items = window.finalCartItems;

      if (Object.keys(items).length > 0) {
        Object.keys(window.finalCartItems).forEach(itemId => {
          if (parseInt(itemId) === prodId) {
            items[itemId] = items[itemId] - currentQty;
            if (items[itemId] <= 0) {
              toggleProductAddToCart(itemId, true);
              delete items[itemId];
            }
          }
        });
      }
    }
    if (Object.keys(items).length === 0) {
      if (window.location.href.includes('/cart')) {
        document.querySelector('button[name="checkout"]').removeAttribute('disabled');
      }
      document.querySelector('span[data-mcbc-check]').dataset.mcbcCheck = 'true';
    } else {
      checkTotal(items);
    }
    return items;
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    this.init();
  }

  init() {
    this.checkComingSoonItem();
  }

  checkComingSoonItem() {
    const cartPage = document.getElementById("cart");
    if(cartPage) {
      cartPage.addEventListener("submit", (evt) => {
        if (evt.submitter.id === 'checkout') {
          this.isComingSoonProduct();
        }
      });
    }
  }
  isComingSoonProduct() {
    const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
    const comingSoonItems = cartItems.querySelectorAll('[data-coming-soon]');
    comingSoonItems.forEach(item => {
      const removeButton = item.querySelector('cart-remove-button');
      const index = removeButton.dataset.index;
      this.updateQuantity(index, 0);
    });
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      if (document.activeElement.parentElement.hasAttribute('data-coming-soon-variant-id')) {
        this.updateQuantity(
          index,
          0,
          document.activeElement.getAttribute('name'),
          event.target.dataset.quantityVariantId
        );
      } else {
        this.updateQuantity(
          index,
          inputValue,
          document.activeElement.getAttribute('name'),
          event.target.dataset.quantityVariantId
        );
      }
    }
  }

  onChange(event) {
    if (window.enable_purchase_limit) {
      let hasPurchaseLimitEnabled = event.target.hasAttribute('data-quantity-inp');
      if (hasPurchaseLimitEnabled) {
        let maxQty = window.limitedQtyProducts[event.target.getAttribute('data-quantity-inp')];
        if (event.target.value > maxQty) {
          event.target.value = maxQty;
        }
      }
    }
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  checkMaxQty(quantity, line) {
    const isLoading = async () => {
      return document.readyState === "complete";
    }

    isLoading().then(r => {
      let input =  document.getElementById(`Drawer-quantity-${line}`);

      if (window.location.href.includes('/cart')) {
        input = document.getElementById(`Quantity-${line}`);
      }

      if (typeof (input) === 'undefined' && input === null)
        return;

      let  prodId = input.dataset.quantityInp !== null ? parseInt(input.dataset.quantityInp) : null;

      const isCartPage = window.location.href.includes('/cart');
      const container = isCartPage ? document.getElementById('MainContent') : document.getElementById('CartDrawer');
      const selectedCartItems = (prodId && container) ? container.querySelectorAll(`input[data-quantity-inp="${prodId}"]`) : [];

      let
          hasPurchaseLimitEnabled = input.hasAttribute('data-quantity-inp'),
          isEmpty = selectedCartItems.length === 0
      ;

      if (!(isEmpty)) {
        checkCurrentItems();
      }

      function checkCurrentItems() {
        if (hasPurchaseLimitEnabled) {
          var total = 0;
          for (let i = 0; i < selectedCartItems.length; i++) {
            let val = parseInt(selectedCartItems[i].value);
            total += val;
          }
          window.finalCartItems[prodId] = total;
        }

        if (total === 0) {
          delete window.finalCartItems[prodId];
        }

        if (Object.keys(window.finalCartItems).length === 0) {
          if (window.location.href.includes('/cart')) {
            document.querySelector('button[name="checkout"]').removeAttribute('disabled');
          }
          document.querySelector('span[data-mcbc-check]').dataset.mcbcCheck = 'true';
        }

        return window.finalCartItems;
      }

      let finalItems = checkCurrentItems();
      if (Object.keys(finalItems).length > 0) {
        checkTotal(finalItems);
      }

      stopNextPropagation = false;
    });
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    if (window.enable_purchase_limit) {
      if (!stopNextPropagation) {
        this.checkMaxQty(quantity, line);
      }
    }

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        stopNextPropagation = false;

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    const cartItemError =  lineItemError?.querySelector('.cart-item__error-text')
    if (lineItemError && !cartItemError.classList.contains('limit__qty')) cartItemError.textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

  if (window.theme.strings.enableRecaptcha == true && typeof (document.getElementById('cart__dynamic-checkout')) != 'undefined'  && document.getElementById('cart__dynamic-checkout') != null){
    document.getElementById('cart__dynamic-checkout').style.pointerEvents = 'none';
    document.getElementById('cart__dynamic-checkout').style.opacity = 0.7;
  }

